import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';
import { getToken } from '@/features/auth/utils/auth';

interface PoolType {
  id: number;
  name: string;
}

const fetchPoolTypes = async (): Promise<PoolType[]> => {
  try {
    // Token verification
    const token = getToken();
    console.log('🔍 Token available for pool-types:', token ? 'YES' : 'NO');
    if (token) {
      console.log('🔍 Token (first 20 chars):', token.substring(0, 20) + '...');
    }
    
    const { data } = await api.get<PoolType[]>('/api/pool-types');
    return data;
  } catch (error) {
    console.error('Error en fetchPoolTypes:', error);
    if (error instanceof Error) {
      throw new Error(`Error al cargar los tipos de piscina: ${error.message}`);
    }
    throw new Error('Error desconocido al cargar los tipos de piscina');
  }
};

export const usePoolTypes = () => {
  const { 
    data: poolTypes = [], 
    isLoading, 
    error,
    isError 
  } = useQuery({
    queryKey: ['pool-types'],
    queryFn: fetchPoolTypes,
    retry: 1,
    refetchOnWindowFocus: false
  });

  return {
    poolTypes,
    isLoading,
    error: isError ? (error instanceof Error ? error.message : 'Error desconocido al cargar los tipos de piscina') : null
  };
}; 